import type { Meta, StoryFn } from '@storybook/react';
import type { PropsWithChildren } from 'react';
import type { FormFieldProps } from './FormField';

import { FormField } from './FormField';

import { InputField } from 'components/InputField';
import { Label } from 'components/Label';
import { Container } from 'storyComponents/Container';

const codeString = '<FormField>{children}</FormField>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/FormField',
  component: FormField,
  argTypes: {
    outerSpace: {
      control: 'boolean',
    },
    inline: {
      control: 'boolean',
    },
    alignStart: {
      control: 'boolean',
    },
  },
  parameters: {
    inspectComponent: FormField,
    codeString: codeString,
  },
} as Meta<PropsWithChildren<FormFieldProps>>;

const Template: StoryFn<PropsWithChildren<FormFieldProps>> = (args) => (
  <Container>
    <FormField {...args}>
      <Label htmlFor="d6aa53fd">Example label</Label>
      <InputField id="d6aa53fd" />
    </FormField>
    <FormField {...args}>
      <Label htmlFor="4e7a2f22">Example very very very long label to display input alingment compared to label</Label>
      <InputField id="4e7a2f22" />
    </FormField>
  </Container>
);

const defaultArgs: Partial<PropsWithChildren<FormFieldProps>> = {
  outerSpace: false,
  inline: false,
  alignStart: false,
};

export const FormFieldExample = Template.bind({});
FormFieldExample.args = {
  ...defaultArgs,
};
